import React from 'react';
import { useDispatch } from 'react-redux';
import moment from 'moment';

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import PersonIcon from '@material-ui/icons/Person';
import ArrowDown from '@material-ui/icons/KeyboardArrowDown';
import IconButton from '@material-ui/core/IconButton';

import BankOfHoursForm from '../../Employee/components/Forms/BankOfHoursForm';
import { createNewEmployee } from '../../../store/actions/employee';
import CustomPopper from '../../../components/Popper/CustomPopper';
import Star from '@material-ui/icons/Star';

const formatMinutes = (string) => {
  if (string && string.length) {
    let hours = '';
    let minutes = '';
    const separator = string.indexOf(':');
    let sign = 1;
    if (string.indexOf('-') === -1) {
      hours = string.slice(0, separator);
    } else {
      hours = string.slice(1, separator);
      sign = -1;
    }

    minutes = string.slice(separator + 1);
    return (parseInt((hours * 60), 10) + parseInt(minutes, 10)) * sign;
  }
  return 0;
};

function BankHoursConfig(props) {
  const dispatch = useDispatch();

  function onUpdateEmpoyee(data) {
    const bankHours = {
      employees: props.employee,
      bankHours: {
        initialValue: formatMinutes(data.initialValue),
        dtFrom: moment(data.dtFrom).format('YYYY-MM-DD'),
        dtTo: moment(data.dtTo).format('YYYY-MM-DD'),
        disableCurrent: !data.hasBankOfHours,
        cumulativeHoursLimit: data.cumulativeHoursLimit
      },
    };
    dispatch(createNewEmployee(bankHours, 'Atualização realizada com sucesso'))
      .then(() => props.close());
  }
  const employeesSelected = props.employees.filter(employee => props.employee.includes(employee.id));
  const employeeNames = employeesSelected.map(employee => ` ${employee.name}`).toString();
  const premium = JSON.parse(localStorage.getItem('privileges')).isExportAfd;

  return (
    <div>

      <Dialog
        open={props.open}
        onClose={props.close}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="md"
        fullWidth
      >
        <DialogTitle id="alert-dialog-title">
          {!premium ?
            < div
              style={{
                display: 'flex',
                alignItems: 'center'
              }}>
              Configurar Banco de Horas< Star style={{ color: '#f2b002' }} />
            </div>
            :
            <div
              style={{
                display: 'flex',
                alignItems: 'center'
              }}>
              Configurar Banco de Horas
            </div>
          }
        </DialogTitle>
        <DialogContent>
          <div style={{
            display: 'flex', alignItems: 'center', marginBottom: '24px', marginLeft: '5px',
          }}
          >
            <PersonIcon
              style={{
                backgroundColor: '#537ccd',
                color: 'white',
                borderRadius: '50%',
                fontSize: '34px',
                padding: '4px',
              }}
            />
            <div style={{ marginRight: 'auto', marginLeft: '10px', display: 'flex', alignItems: 'center' }}>
              {employeeNames.length > 90 ? (
                <>
                  <span>{`${employeeNames.slice(0, 90)}...`}</span>
                  <CustomPopper
                    element={onClick => (
                      <IconButton aria-label="Mostrar detalhes" size="small" onClick={onClick} style={{ padding: '4px' }}>
                        <ArrowDown />
                      </IconButton>
                    )}
                    content={employeeNames}
                  />
                </>
              ) : <span>{employeeNames}</span>}
            </div>
          </div>
          <BankOfHoursForm
            data={props.data || []}
            updateEmployee={onUpdateEmpoyee}
            loading={false}
            departments={[]}
            offices={[]}
            innerSubmit
            title="Cadastrar"
            close={props.close}
          />
        </DialogContent>
      </Dialog>

    </div >
  );
}

export default BankHoursConfig;

